export class callReceived {

    constructor(callReceivedJson) {
        this.callId			= callReceivedJson.CallId;        	
        this.callOutId		= callReceivedJson.CallOutId;     				
        this.idCamp		    = callReceivedJson.Id;            
        this.callKey		= callReceivedJson.CalKey;    
        this.callType	    = callReceivedJson.CallType;    
        this.isQueueCall	= callReceivedJson.IsQueueCall;    				
        this.waitingTime	= callReceivedJson.WaitingTime;        
        this.holdTime	    = callReceivedJson.HoldTime;    
        this.phone			= callReceivedJson.Phone;       			
        this.port	        = callReceivedJson.Port;
        this.wrapUpTime	    = callReceivedJson.WrapUpTime;    
        this.numberDNIS		= callReceivedJson.DNIS;   
        this.dataContact	= callReceivedJson.DataContact;      
        this.dataHeaders	= callReceivedJson.DataHeaders;        			
        this.engineId	    = callReceivedJson.EngineId;    
        this.isACDTransfer	= callReceivedJson.IsACDTransfer;       				
        this.dataKeyValue	= callReceivedJson.DataKeyValue;
        this.holdCall       = callReceivedJson.holdCall !== undefined ? callReceivedJson.holdCall : callReceivedJson.HoldCall;
        this.audio			= callReceivedJson.Audio;        	
        this.action			= callReceivedJson.action;       			
        this.campName   	= callReceivedJson.Description;
        this.frame          = callReceivedJson.Frame;
    }
}